export enum IntegrationType {
  POLAR = 'POLAR',
  POLAR_TEAM = 'POLAR_TEAM',
  GARMIN = 'GARMIN',
  GPEXE = 'GPEXE',
  FIELD_WIZ = 'FIELD_WIZ',
  CATAPULT = 'CATAPULT'
}
